import { Box } from '@mui/material';
import { FunctionComponent, useContext } from 'react';
import { ViewHeader } from '../../../../core/components/ViewHeader/ViewHeader';
import { AppContext } from '../../../../core/config';
import { useAppTranslate, useBusinessContext } from '../../../../core/hooks';
import { Loader } from '../../../../ui/components';
import { useChartSettings } from '../../../chart-settings/hooks';
import { SlaStatisticsBusinessContextConfig } from '../../config';
import { useSlaMonitoredServicesApiGet } from '../../hooks';
import { SlaStatisticsTable } from '../SlaStatisticsTable/SlaStatisticsTable';

export const SlaStatistics: FunctionComponent = () => {
  const { customerId } = useContext(AppContext);
  const { chartSettings, setResolution, setTimespan } = useChartSettings();
  const translate = useAppTranslate();
  useBusinessContext(SlaStatisticsBusinessContextConfig);
  const {
    slaMonitoredClassesOfService,
    isFetching,
    isFetched,
  } = useSlaMonitoredServicesApiGet(customerId, chartSettings.timespan);

  return <Box sx={{ p: 2 }}>
    <ViewHeader title={translate('title')} />
    {isFetching
      ? <Loader loading={isFetching} />
      : (isFetched && slaMonitoredClassesOfService && (
          <SlaStatisticsTable
            slaMonitoredClassesOfService={slaMonitoredClassesOfService}
            chartSettingsInteraction={{ chartSettings, setResolution, setTimespan }}
            customerId={customerId}
          />
        )
      )
    }
  </Box>;
};
